import cn from "classnames";
import Select from "../Form/Select";
import Checkbox from "../Checkbox";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

const PropertyFeaturesSection = ({
  values,
  errors,
  touched,
  handleChange,
  styles,
  difference,
  router,
  accompaning,
  getAssist,
  lotTechnical,
  heatingMode,
  heatingModeType,
  technical,
  checkboxesDifference,
  filtersSelect,
  supportFiltersSelect,
  balconyFiltersSelect,
  handleCheckboxClick,
  handleSupportCheckboxClick,
  handleBaclconyCheckboxClick,
}) => (
  <>
    {values["type"] !== "form_input_lot" &&
      values["type"] !== "menu_office" && (
        <>
          <div
            style={{
              height: 1,
              width: "100%",
              background: "#ddd",
              margin: "20px 0",
            }}
          />
          <div key={`property-form-following-data`}>
            <label key={`property-form-following-obj`}>Prateci objekti</label>
            <Row cols={12} className={"d-flex"}>
              {accompaning().map((fac, index) => (
                <Col
                  key={`accompaning-column-${index}`}
                  className="mb-2 mt-4 col-sm-6 col-md-3 col-lg-2"
                >
                  <Checkbox
                    key={`form-checkbox-accompanying-fac-${index}`}
                    text={fac.label}
                    isDifference={checkboxesDifference[fac.id]}
                    hp
                    initiallyChecked={filtersSelect[fac.id]}
                    onCheck={(value) => handleCheckboxClick(fac.id, value)}
                  />
                </Col>
              ))}
            </Row>
          </div>
        </>
      )}

    {values["type"] !== "form_input_lot" &&
      values["type"] !== "form_input_garages" && (
        <>
          <div
            key={`property-form-extensions`}
            style={{
              height: 1,
              width: "100%",
              background: "#ddd",
              margin: "20px 0",
            }}
          />
          <label key={`property-form-label-facilities`} className="mb-3">
            Pomagala
          </label>
          <div
            key={`property-form-facilities`}
            className="d-flex justify-content-start"
          >
            {getAssist().map((fac, index) => (
              <Checkbox
                key={`form-checkbox-assist-fac-${index}`}
                text={fac.label}
                hp
                isDifference={checkboxesDifference[fac.id]}
                initiallyChecked={supportFiltersSelect[fac.id]}
                onCheck={(value) => handleSupportCheckboxClick(fac.id, value)}
              />
            ))}
          </div>
        </>
      )}

    {values["type"] === "form_input_lot" && (
      <>
        <label key={`property-form-label-tech-1`} className="mb-3">
          Tehnicka opremljenost
        </label>
        <div key={`property-form-tech`} className="d-flex">
          {lotTechnical().map((fac, index) => (
            <Checkbox
              key={`form-checkbox-lotTechnical-${index}`}
              isDifference={checkboxesDifference[fac.id]}
              text={fac.label}
              hp
              initiallyChecked={filtersSelect[fac.id]}
              onCheck={(value) => handleCheckboxClick(fac.id, value)}
            />
          ))}
        </div>
      </>
    )}

    {values["type"] !== "form_input_lot" &&
      values["type"] !== "form_input_garages" && (
        <>
          <Select
            key={`form-select-propertyHeat`}
            values={values}
            options={heatingMode()}
            className={cn({
              [styles.editedObject]:
                difference.includes("property_heat") &&
                router.includes("properties/edit"),
            })}
            formName="property_heat"
            handleChange={handleChange}
            placeholder="Izaberite način grejanja"
            label="Način grejanja:"
            errors={errors}
            touched={touched}
            ariaLabel="Način grejanja"
          />
          <Select
            key={`form-select-propertyHeatType`}
            values={values}
            options={heatingModeType()}
            formName="property_heat_type"
            className={cn({
              [styles.editedObject]:
                difference.includes("property_heat_type") &&
                router.includes("properties/edit"),
            })}
            handleChange={handleChange}
            placeholder="Izaberite vrstu goriva"
            label="Vrsta goriva:"
            errors={errors}
            touched={touched}
            ariaLabel="Vrsta goriva"
          />
        </>
      )}

    {values["type"] !== "form_input_lot" && (
      <div key={`property-form-tech-fac-div-2`}>
        <label key={`property-form-label-tech-2`} className="mt-3">
          Tehnicka Opremljenost
        </label>
        <Row cols={12}>
          {technical.map((fac, index) => {
            if (
              values["type"] === "top_search_cat_menu_apartments" ||
              values["type"] === "menu_office"
                ? fac.id !== "struja" && fac.id !== "vodovod"
                : true
            ) {
              return (
                <Col
                  className="mb-2 mt-4 col-sm-6 col-md-3 col-lg-2"
                  key={index}
                >
                  <Checkbox
                    key={`form-checkbox-technical-fac-${index}`}
                    isDifference={checkboxesDifference[fac.id]}
                    text={fac.label}
                    hp
                    initiallyChecked={balconyFiltersSelect[fac.id]}
                    onCheck={(value) =>
                      handleBaclconyCheckboxClick(fac.id, value)
                    }
                  />
                </Col>
              );
            }
            return null;
          })}
        </Row>
      </div>
    )}
  </>
);

export default PropertyFeaturesSection;
